import { TMDB_axios_adapter } from "./TMDB_axios_adapter";
import ENDPOINTS_TMDB from "./TMDB_constant";

/**
 * 
 * UserName : RahulNexintain
 * Email : rahul@nexintain.com
 * https://www.themoviedb.org/settings/api
 * https://developer.themoviedb.org/reference/intro/getting-started
 * 
 */

const TMDB_api_service = {
    discoverAllMoviesList: async (params = {
        "include_adult": false,
        "include_video": false,
        "language": "en-US",
        "page": 1,
        "sort_by": "popularity.desc"
    }) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.MOVIE}`, { params });
            return response;
        } catch (error) {
            return error;
        }
    },

    searchByMovieTitle: async (title,year,type, params = {"include_adult": false,"language": "en-US","region":"India" }) => {    
        //"year","primary_release_year"
        const tvPromise = TMDB_axios_adapter
        .get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.SEARCH_TV_SHOW_BY_TITLE}`, {
          params: { ...params, query: title, year }
        });
    
      const moviePromise = TMDB_axios_adapter
        .get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.SEARCH_MOVIE_BY_TITLE}`, {
          params: { ...params, query: title, year }
        });
    
      try {
        if (type?.toLowerCase() === "series" || type?.toLowerCase() === "tv") {
          const response = await tvPromise;
          return { source: "tv", ...response.data };
        } else if (type?.toLowerCase() === "movie") {
          const response = await moviePromise;
          return { source: "movie", ...response.data };
        } else {
            // Try both if type is not clearly defined
            const [movieResult] = await Promise.allSettled([moviePromise]);
      
            if (
              movieResult.status === "fulfilled" &&
              movieResult.value?.data?.results?.length > 0
            ) {
                /**get here movie detail and add */
              return { source: "movie", ...movieResult.value.data };
            } 
            // else if (
            //   tvResult.status === "fulfilled" &&
            //   tvResult.value?.data?.results?.length > 0
            // ) {
            //     /**get here tv detail and add */
            //   return { source: "tv", ...tvResult.value.data };
            // } 
            else {
              throw new Error("No results found in both movie and tv search");
            }
          }
        } catch (error) {
          return { error: true, details: error };
        }
    },

    searchByIMDBID: async (imdbId, params = { "external_source": "imdb_id" }) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ROUTES_TMDB.FIND}/${imdbId}`,  {params});
            return response.data;
        } catch (error) {
            return error;
        }
    },

    upcomingMoviesList: async (params = {
        "language": "en-US",
        "page": 1
    }) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.UPCOMING}`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    popularMoviesList: async (params = {
        "language": "en-US",
        "page": 1
    }) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.UPCOMING}`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    topRatedMoviesList: async (params = {
        "language": "en-US",
        "page": 1
    }) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.TOP_RATED}`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    movieDetails: async (movieId,params = {"language":"en-US"}) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.MOVIE_DETAIL}/${movieId}`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    tvShowDetails: async (tvShowId,params = {"language":"en-US"}) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.TV_DETAIL}/${tvShowId}`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    movieCreditAndCastDetails: async (movieId,params = {"language":"en-US"}) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.MOVIE}/${movieId}/credits`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    specificCreditDetails: async (creditId,params) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ROUTES_TMDB.CREDIT}/${creditId}`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    externalIDs: async (movieId,params) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.MOVIE}/${movieId}/external_ids`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    movieImages: async (movieId) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.MOVIE_DETAIL}/${movieId}/images`);
            return response.data;
        } catch (error) {
            return error;
        }
    },

    tvShowsImages: async (movieId) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.TV_DETAIL}/${movieId}/images`);
            return response.data;
        } catch (error) {
            return error;
        }
    },

    getKeywords: async (movieId,params) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.MOVIE}/${movieId}/keywords`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    getVideosAndTitlesAvilableOnOtherSource : async (movieId,params = {"language":"en-US"}) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.MOVIE}/${movieId}/videos`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },

    watchProviders : async (movieId,params = {"language":"en-US"}) => {
        try {
            const response = await TMDB_axios_adapter.get(`${ENDPOINTS_TMDB.ENDPOINTS_TMDB.MOVIE}/${movieId}/watch/providers`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },
};

export default TMDB_api_service;